<template>
	<button
		type="button"
		class="hover:ring-4 hover:ring-gray-100 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
		role="switch"
		aria-checked="false"
		:class="[val ? 'bg-orange-500' : 'bg-gray-200']"
		@click="toggle()"
	>
		<!-- <span class="sr-only">Use setting</span> -->

		<span
			aria-hidden="true"
			class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
			:class="val ? 'translate-x-5' : 'translate-x-0'"
		></span>
	</button>
</template>

<script>
export default {
	props: {
		value: {
			type: Boolean,
			required: true,
		},
		label: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			val: this.value || false,
		};
	},
	methods: {
		toggle() {
			this.val = !this.val;
		},
	},
	watch: {
		val(v) {
			this.$emit("input", v);
			this.$emit("change");
		},
	},
};
</script>
